module.exports = __webpack_public_path__ + "img/advantage.746b3f69.jpg";